export const manifest = (() => {
function __memo(fn) {
	let value;
	return () => value ??= (value = fn());
}

return {
	appDir: "_app",
	appPath: "_app",
	assets: new Set(["Logo/logo.png","robots.txt"]),
	mimeTypes: {".png":"image/png",".txt":"text/plain"},
	_: {
		client: {start:"_app/immutable/entry/start.BYvkQrry.js",app:"_app/immutable/entry/app.3j0FrPjI.js",imports:["_app/immutable/entry/start.BYvkQrry.js","_app/immutable/chunks/o-fdcMLv.js","_app/immutable/chunks/BZTNq1Um.js","_app/immutable/chunks/kwBiegc5.js","_app/immutable/entry/app.3j0FrPjI.js","_app/immutable/chunks/BZTNq1Um.js","_app/immutable/chunks/KZK0-soZ.js","_app/immutable/chunks/kwBiegc5.js","_app/immutable/chunks/BGfRHZdV.js"],stylesheets:[],fonts:[],uses_env_dynamic_public:false},
		nodes: [
			__memo(() => import('./nodes/0.js')),
			__memo(() => import('./nodes/1.js')),
			__memo(() => import('./nodes/2.js')),
			__memo(() => import('./nodes/3.js'))
		],
		remotes: {
			
		},
		routes: [
			{
				id: "/",
				pattern: /^\/$/,
				params: [],
				page: { layouts: [0,], errors: [1,], leaf: 2 },
				endpoint: null
			},
			{
				id: "/api/countdown",
				pattern: /^\/api\/countdown\/?$/,
				params: [],
				page: null,
				endpoint: __memo(() => import('./entries/endpoints/api/countdown/_server.js'))
			},
			{
				id: "/workshops",
				pattern: /^\/workshops\/?$/,
				params: [],
				page: { layouts: [0,], errors: [1,], leaf: 3 },
				endpoint: null
			}
		],
		prerendered_routes: new Set([]),
		matchers: async () => {
			
			return {  };
		},
		server_assets: {}
	}
}
})();

export const prerendered = new Set([]);

export const base = "";